import { HoldRepeatController } from "../helpers/hold_repeat"

// +/- stepper over a minutes display backing a hidden HH:MM field.
//
// Two-way, for the same reason as break_time_minutes_controller: the statutory
// break rule raises the HIDDEN field (that is the one that submits), and without
// the return leg the big number in the middle of the stepper keeps showing the
// value the employee stepped to while the entry books a different one.
export default class extends HoldRepeatController {
  static targets = ["display", "hidden"]
  static values = { step: { type: Number, default: 5 } }

  connect() {
    super.connect()
    this._applyHidden = () => this.readHidden()
    this.hiddenTarget.addEventListener("change", this._applyHidden)
  }

  disconnect() {
    super.disconnect()
    this.hiddenTarget.removeEventListener("change", this._applyHidden)
  }

  get currentMinutes() {
    return parseInt(this.displayTarget.textContent) || 0
  }

  set currentMinutes(value) {
    const clamped = Math.max(0, Math.min(1440, value))
    this.displayTarget.textContent = clamped
    const hours = Math.floor(clamped / 60)
    const mins = clamped % 60
    this.hiddenTarget.value = String(hours).padStart(2, "0") + ":" + String(mins).padStart(2, "0")
    this.hiddenTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // By value, not by a flag around our own dispatch — see the same guard in
  // break_time_minutes_controller. It matters more here: the +/- buttons fire a
  // click, which is neither change nor input, so the raise break_rule_controller
  // makes in response to our dispatch is the ONLY chance this display gets to
  // learn about it. A flag would drop it and leave the stepper showing a break
  // the entry is not booked with.
  readHidden() {
    const parts = String(this.hiddenTarget.value || "").split(":")
    if (parts.length < 2) return

    const minutes = parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10)
    if (Number.isNaN(minutes) || minutes === this.currentMinutes) return

    this.displayTarget.textContent = minutes
  }

  // Compared after the change event has run: break_rule_controller raises a break that
  // drops below the statutory minimum straight back (readHidden). Whenever the value
  // did not land where we put it, the rule has taken over and a held button stops
  // there instead of fighting it.
  step(direction) {
    const before = this.currentMinutes
    const next = Math.max(0, Math.min(1440, before + direction * this.stepValue))
    if (next === before) return false

    this.currentMinutes = next
    return this.currentMinutes === next
  }
}
